import { Role } from "./role";

export interface Perfil {
  id: number;
  descricao: string;
  perfil: any;
  roles: Role[];
  statusPerfil: any;
  tipo: string;
}


export enum PerfilEnum {
  Administrador = 'Administrador',
  Validador = 'Validador',
  Atualizador = 'Atualizador',
  Aprovador = 'Aprovador',
  Usuario = 'Usuario'
}



export interface PerfilElement{
  id: number;
  nomePerfil: string;
  perfil: string;
  roles: Role[];
  statusPerfil: any;
  tipo: string;
}


  export class PerfilFiltro{
    perfil?: string;
    status?: string;
  }

  export  interface Permissao {
    leitura: boolean;
    gravacao: boolean;
    inativacao: boolean;
  }

  export interface Tela {
    nome: string;
    permissoes: Permissao;
    roles: Role[];
  }

  export interface Categoria {
    nome: string;
    telas: Tela[];
  }




